// extracted by mini-css-extract-plugin
export default {"rolesSectionContainer":"RolesSectio_rolesSectionContainer__EIvPu","title":"RolesSectio_title__H9iiB","roles":"RolesSectio_roles__GjfRl"};